import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "photos/rsz_1rsz_me1.jpg",
        "alt": "Graduation Photo",
        "title": "Joshua Cheung"
      }}></img></p>
    <h1>{`Joshua Cheung`}</h1>
    <h3>{`Computer Science B.S at University of California, Santa Cruz`}</h3>
    <p>{`Looking for Software Engineer Full-time Opportunities! `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      